module.exports = {"label":{"date":"Date (UTC)"},"timeRel":{"on":"on","before":"before","after":"after","beforeMonth":"before","afterMonth":"after"}}